import React from 'react';
import './vision.css';

const visionPoints = [
  {
    title: 'Global Innovation',
    description: 'We aim to be a global leader in innovation, creating breakthrough technologies that redefine industry standards and empower people worldwide.',
    icon: '🌐',
  },
  {
    title: 'Tech with Purpose',
    description: 'Our vision is to develop technology with a meaningful purpose that solves real-world problems and creates sustainable value.',
    icon: '💡',
  },
  {
    title: 'Grow Together',
    description: 'We believe in collective growth – fostering collaboration with clients, partners, and employees to achieve mutual success.',
    icon: '🌱',
  },
];

function Vision() {
  return (
    <div className="vision-page">
      <div className="interactive-bg" />
      <div className="vision-cards">
        {visionPoints.map(({ title, description, icon }, idx) => (
          <div key={idx} className="vision-card" tabIndex={0} role="button" aria-pressed="false">
            <div className="vision-icon">{icon}</div>
            <h2 className="vision-title">{title}</h2>
            <p className="vision-description">{description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Vision;
